import axios from 'axios'

import { USER_SERVICE_BASE_URL } from '../config'
import { checkAuthorization } from '../functions/authHelpers'

/**
 * This is the only file refresh token existence need to be known.
 * Every other backend apis use access token and can use GetValidAccessToken function
 */
const refreshToken = async () => {
  try {
    const response = await axios.post(
      `${USER_SERVICE_BASE_URL}/tokens/refresh`,
      {
        refresh_token: localStorage.getItem('refreshToken')
      },
      { withCredentials: true }
    )
    if (response.status === 200 || response.status === 201) {
      return {
        status: 'ok',
        data: {
          authToken: response.data.access_token,
          refreshToken: response.data.refresh_token
        },
        error: undefined
      }
    }
    throw new Error(response.data.message)
  } catch (error) {
    return {
      status: 'error',
      data: null,
      error: error.message
    }
  }
}

function once<T>(fn: () => Promise<T>): () => Promise<T> {
  let executed = false
  let result: Promise<T>
  return async () => {
    if (!executed) {
      executed = true
      result = fn()
    }
    try {
      await result
    } catch (error) {
      // ignore error
    }
    executed = false
    return result
  }
}

const refreshTokenOnce = once(() => refreshToken())

export async function GetValidAccessToken(): Promise<string | null> {
  const auth = checkAuthorization()
  if (auth.status === 'ok' && auth.data?.accessTokenExpired) {
    const result = await refreshTokenOnce()
    if (result.status === 'ok' && result.data !== null) {
      localStorage.setItem('authToken', result.data.authToken)
      localStorage.setItem('refreshToken', result.data.refreshToken)
      return result.data?.authToken
    }
  }
  return localStorage.getItem('authToken')
}
